const ForYou = "ForYou";

const sectionTypes = {
  ForYou: "For You",
  Favourite: "Favourites",
  TopTracks: "Top Tracks",
  RecentlyPlayed: "Recently Played",
};

export { sectionTypes };
